import { Calendar, Users, TrendingUp, Clock } from 'lucide-react';
import { Card, CardHeader, CardTitle } from '../ui/Card';

const statConfig = [
  {
    key: 'activeEventsToday',
    label: 'Events Today',
    icon: Calendar,
    color: 'bg-wrg-blue-50 text-wrg-blue-600'
  },
  {
    key: 'totalEntriesThisWeek',
    label: 'Entries This Week',
    icon: Users,
    color: 'bg-green-50 text-green-600'
  },
  {
    key: 'pendingResults',
    label: 'Pending Results',
    icon: TrendingUp,
    color: 'bg-amber-50 text-amber-600',
    highlight: true
  },
  {
    key: 'upcomingEventsThisMonth',
    label: 'Events This Month',
    icon: Clock,
    color: 'bg-purple-50 text-purple-600'
  }
];

export default function StatsOverview({ stats = {}, loading }) {
  if (loading) {
    return (
      <Card padding="compact">
        <CardHeader border={false} className="mb-3 pb-0">
          <div className="h-5 w-24 bg-slate-100 rounded animate-pulse" />
        </CardHeader>
        <div className="space-y-3">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 bg-slate-100 rounded animate-pulse" />
                <div className="h-4 w-28 bg-slate-100 rounded animate-pulse" />
              </div>
              <div className="h-6 w-10 bg-slate-100 rounded animate-pulse" />
            </div>
          ))}
        </div>
      </Card>
    );
  }

  return (
    <Card padding="compact">
      <CardHeader border={false} className="mb-3 pb-0">
        <CardTitle>Overview</CardTitle>
      </CardHeader>
      <div className="space-y-3">
        {statConfig.map((stat) => {
          const Icon = stat.icon;
          const value = stats[stat.key] ?? 0;
          const isHighlighted = stat.highlight && value > 0;

          return (
            <div key={stat.key} className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className={`w-9 h-9 rounded flex items-center justify-center ${stat.color}`}>
                  <Icon className="w-4 h-4" />
                </div>
                <span className="text-sm text-slate-600">{stat.label}</span>
              </div>
              <span className={`text-lg font-semibold ${isHighlighted ? 'text-amber-600' : 'text-slate-800'}`}>
                {value}
              </span>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
